import ADD_NEW_HIRE_ROUTE from './addNewHireRoute';
import EDIT_PROFILE_TEMPLATE_ROUTE from './editProfileTemplateRoute';
import EDIT_WORKFLOW_ROUTE from './editWorkflowRoute';
import EDIT_PACKET_ROUTE from './editPacketRoute';
import MANAGE_PACKETS_ROUTE from './managePacketsRoute';
import POLICY_ROUTES from './policyRoutes';
import OFFBOARDING_ROUTES from './offboardingRoutes';
import WORKING_PATTERNS_ROUTES from './workingPatternsRoutes';
import ABSENCE_MANAGEMENT_ROUTES from './absenceManagementRoutes';
import BULK_ONBOARDING_ROUTES from './bulkOnboardingRoutes';
import REHIRE_ROUTE from './rehireRoute';
import ROLE_ROUTES from './roleRoutes';
import IMPORT_PENDING_HIRES_ROUTE from './importPendingHireRoute';
import CREATE_OR_EDIT_REPORT from './createOrEditReportsRoute';
import ROLE_CHANGE_ROUTES from './roleChangeRoutes';
import ATS_ONBOARD_ROUTE from './atsOnboardRoute';

export default [
  ADD_NEW_HIRE_ROUTE,
  ...BULK_ONBOARDING_ROUTES,
  REHIRE_ROUTE,
  ATS_ONBOARD_ROUTE,
  ...POLICY_ROUTES,
  ...ROLE_ROUTES,
  ...IMPORT_PENDING_HIRES_ROUTE,
  EDIT_PROFILE_TEMPLATE_ROUTE,
  EDIT_WORKFLOW_ROUTE,
  EDIT_PACKET_ROUTE,
  MANAGE_PACKETS_ROUTE,
  ...OFFBOARDING_ROUTES,
  ...WORKING_PATTERNS_ROUTES,
  ...CREATE_OR_EDIT_REPORT,
  ...ABSENCE_MANAGEMENT_ROUTES,
  ...ROLE_CHANGE_ROUTES,
];
